<template>
  <div>
    <el-steps :active="1" finish-status="success">
      <el-step title="经办人认证"></el-step>
      <el-step title="备案信息录入"></el-step>
      <el-step title="付款"></el-step>
    </el-steps>

    <el-empty v-if="result == 'SUCCESS'" style="margin-top: 150px" description="认证成功" :image="require('@/assets/certification-successful.png')"></el-empty>

    <el-empty v-else style="margin-top: 150px" description="认证失败" :image="require('@/assets/authentication-failed.png')"></el-empty>

    <div class="bottom-box">
      <el-button v-if="result == 'SUCCESS'" type="primary" style="width: 40%" @click="nextStep()">下一步</el-button>

      <el-button v-else type="primary" style="width: 40%" @click="again()">重新认证</el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: "index",
  created() {
    let id = this.$route.params.id || null
    this.id = id
    this.result = this.$route.query.result
  //   http://192.168.130.193:8081/#/h5/authentication/1714367544775680?result=SUCCESS&checkId=1714367544775680
  },
  data() {
    return {
      id: '',
      result: '',
    }
  },
  methods: {
    nextStep(){
      this.$router.replace({
        path: "/h5/physicsSeal/" + this.id,
      });
    },
    again(){
      this.$router.replace({
        path: "/h5/operatorAuthentication",
      });
    },
  }
}
</script>

<style scoped lang="less">
.el-step{
  text-align: left;
}

.el-steps{
  padding: 10px 20px 0 20px;
  background-color: #FFFFFF;
}

.bottom-box{
  width: 100%;
  height: 80px;
  position: fixed;
  bottom: 0;
  background-color: #FFFFFF;
  padding-top: 20px;
  z-index: 10;
}
</style>
